import { clientUtils } from '@/utils/trpc'

type Result = Record<string, string>
let timer: ReturnType<typeof setTimeout> | null = null
let resolvers: ((value: Result) => void)[] = []
let adTemplateQueue: string[] = []

const BATCH_SIZE = 20
const BATCH_DELAY = 50 // in ms

const _cache: Result = {}

const fetchTemplateEditorUrls = async (ids: string[]) => {
  const response = await clientUtils.batchTemplateEditorUrl.ensureData({
    templateType: 'ad',
    templateIds: ids,
  })
  return response
}

const flushQueue = () => {
  const ids = [...adTemplateQueue]
  const currentResolvers = [...resolvers]
  adTemplateQueue = []
  resolvers = []
  timer = null
  if (ids.length === 0) {
    return
  }

  ids.forEach((id) => {
    if (_cache[id]) {
      currentResolvers.forEach((resolve) => resolve({ [id]: _cache[id] }))
      ids.splice(ids.indexOf(id), 1) // Remove from ids to avoid fetching again
      return
    }
  })

  fetchTemplateEditorUrls(ids).then((result) => {
    ids.forEach((id) => {
      if (id) {
        _cache[id] = result[id] || ''
      }
    })
    currentResolvers.forEach((resolve) => resolve(result))
  })
}

export const enqueueAdTemplate = (creativeId: string): Promise<Result> => {
  return new Promise((resolve) => {
    adTemplateQueue.push(creativeId)
    resolvers.push(resolve)
    if (adTemplateQueue.length >= BATCH_SIZE) {
      flushQueue()
    } else if (!timer) {
      timer = setTimeout(flushQueue, BATCH_DELAY)
    }
  })
}
